import { __ } from '@wordpress/i18n';
const { RichText, InnerBlocks } = wp.blockEditor;

export default ({ attributes, className }) => {
    return (
        <div className={ className }>
            <div className="wrapper">
                <InnerBlocks.Content />

                <RichText.Content
                tagName="p"
                className="Subtitle"
                value={attributes.subtitle}
                />
            </div>
        </div>
    )
} 